<div class="append-container">
  <kendo-stacklayout class="grid-layout-container" [gap]="2" [align]="{ horizontal: hAlign}">
    <div *ngFor="let m of modulos">
      <div class="locker-wrapper">
        <kendo-gridlayout [rows]="m.linhas" [cols]="m.colunas" [gap]="2">
          <kendo-gridlayout-item *ngFor="let c of m.compartimentos" [col]="c.coluna" [row]="c.linha"
            [rowSpan]="c.linhaSpan"  class="box rect">

            <span kendoTooltip title="{{getTranslatedText(c)}}">
              <small class="boxmicro">
                <button kendoButton [disabled]="btnDisabled(c)" [style]="estadoBtn(c)" (click)="openEditCompartimento(c)">
                  {{c.nome}}
                </button>
              </small>
              <small class="getText">
                {{getText(c)}}
              </small>
            </span>
          </kendo-gridlayout-item>
        </kendo-gridlayout>
      </div>
    </div>
  </kendo-stacklayout>
  <br>
  <br>
</div>